import * as actions from './actions';

export const INITIAL_STATE = {
    rows: [],
    loading: false
};

export default function reducer(state = INITIAL_STATE, action = {}) {
    switch (action.type) {
        case actions.SET_MONITOR_ROWS: {
            return {
                ...state,
                rows: action.rows,
                loading: false
            };
        }
        case actions.FETCH_MONITOR_ROWS_FAILED: {
            return {
                ...state,
                loading: false
            };
        }
        case actions.LOADING: {
            return {
                ...state,
                loading: true
            };
        }
        case actions.ADD_CSA_TO_ACADIA_SOFT_SUCCESS: {
            return {
                ...state,
                loading: false
            };
        }
        case actions.ADD_CSA_TO_ACADIA_SOFT_ERROR: {
            return {
                ...state,
                loading: false
            };
        }
        case actions.DELETE_CSA_FROM_ACADIA_SOFT_SUCCESS: {
            return {
                ...state,
                loading: false
            };
        }
        case actions.DELETE_CSA_FROM_ACADIA_SOFT_ERROR: {
            return {
                ...state,
                loading: false
            };
        }
        default:
            return state;
    }
}
